import React from 'react';
import ReactDOM from 'react-dom';
import singleSpaReact from 'single-spa-react';
import { setConfig } from '@creditas-lab/auth-sdk';
import { envVars } from './envVars';
import App from './App';

if (envVars.APP_ENV !== 'production') {
  setConfig('staging');
}

// Add this part to the file to import GTM
if (process.env.APP_ENV !== 'development') {
  // eslint-disable-next-line global-require
  // require('./libs/gtm');
}

const lifecycles = singleSpaReact({
  React,
  ReactDOM,
  loadRootComponent: () => {
    return new Promise<React.FunctionComponent>((resolve) => {
      if (process.env.USE_MSW_MOCK === 'true') {
        import('./mocks/browser').then(({ worker }) => {
          worker.start({
            onUnhandledRequest: 'bypass',
          });
          resolve(App as React.FunctionComponent);
        });
      } else {
        resolve(App as React.FunctionComponent);
      }
    });
  },
  // errorBoundary(err, info, props): null {
  //   // Customize the root error boundary for your microfrontend here.
  //   return null;
  // },
});

export const { bootstrap, mount, unmount } = lifecycles;
